export default "/images/70a8aa52a83d68256166592cf4467564.avif";